import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Image from "../ui/Image";
import Breadcrumb from "../Pages/Breadcrumb";
import React from "react";
import { ChevronLeft, ChevronRight, ArrowLeft, CalendarRange, PersonStanding, CalendarHeart } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useHomeSection from "../../hooks/useHomeSection";
import { useQuery } from "@tanstack/react-query";
import { useLanguage } from "../../store/language-context";
import { useTranslation } from "react-i18next";
import image5 from "../../assets/icons/group-1.png";
import img7 from "../../assets/icons/group-2.png";
import img8 from "../../assets/icons/group-4.png";
import img9 from "../../assets/icons/group-3.png";

// const AnotherAchievments = React.memo(() => {
//   const { data: achievements, isLoading } = useHomeSection({ sectionName: 'ivory_Achievements' });
//   const { t } = useTranslation();

//   return (
//     <div className="container">
//       <section className="md:flex lg:justify-between flex-wrap lg:items-center gap-3  mt-5">

//       </section>
//       <section className="flex items-center justify-between gap-2">

//         <button className='flex justify-center items-center size-8 border-2 border-secondary-tw rounded-md text-secondary-tw prev-new'>
//           <ChevronRight size={22} />
//         </button>

//         <Swiper
//           modules={[Navigation, Pagination, Autoplay]}
//           loop={true}
//           navigation={{
//             nextEl: '.next-new',
//             prevEl: '.prev-new'
//           }}
//           spaceBetween={30}
//           slidesPerView={4}
//           breakpoints={{
//             0: { slidesPerView: 1 },
//             680: { slidesPerView: 2 },
//             992: { slidesPerView: 3 },
//             1200: { slidesPerView: 4 }
//           }}
//           autoplay={{ delay: 3000, disableOnInteraction: true }}
//           draggable={true}
//         >
//           {isLoading ? (
//             <div>
//               <div className="grid grid-cols-3 gap-4 max-2xl:grid-cols-2 max-lg:grid-cols-1">
//                 {[1, 2, 3].map((i) => (
//                   <div key={i} className={`relative flex items-center justify-center flex-col ${i === 2 || i === 1 ? 'lg:flex max-lg:hidden' : ''}`}>
//                     <div className="l-load w-96 h-60 rounded-md max-lg:w-full"></div>
//                     <div className="absolute z-20 bottom-3 flex flex-col items-center w-full px-2 space-y-1">
//                       <div className="l-load-dt w-3/4 h-5 rounded"></div>
//                       <div className="l-load-dt w-40 h-8 rounded-md"></div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ) : (
//             // Content
//             achievements.map((item) => (
//               <SwiperSlide key={item.id}>
//                 <div className='relative flex justify-center flex-col'>
//                   <div className="relative z-0">
//                     <Image
//                       src={item.image}
//                       alt={item.title}
//                       className="w-96 h-60 rounded-md z-0"
//                     />
//                   </div>
//                   <div className="w-full z-10 absolute bg-[var(--light-red)] h-full rounded-md"></div>
//                   <div className="absolute z-20 bottom-3 flex flex-col items-center w-full !px-2 space-y-1">
//                     <p className='text-white'>{item.title}</p>
//                     <span className='flex items-center gap-2 bg-secondary-tw px-2 py-1 !text-white w-fit rounded-md'>
//                       <Link to={`/achievements/${item?.id}`} className='!text-white'>
//                         {t('custom.more-details')}
//                       </Link>
//                       <span>
//                         <ArrowLeft size={18} />
//                       </span>
//                     </span>
//                   </div>
//                 </div>
//               </SwiperSlide>
//             ))
//           )}
//         </Swiper>

//         <button className='flex justify-center items-center size-8 border-2 border-secondary-tw rounded-md text-secondary-tw next-new'>
//           <ChevronLeft size={22} />
//         </button>

//       </section>
//     </div>
//   )
// });
const AnotherAchievments = React.memo(() => {
  const { data: achievements, isLoading } = useHomeSection({ sectionName: 'ivory_Achievements' });
  const { t } = useTranslation();

  return (
    <div className="container">
      <section className="md:flex lg:justify-between flex-wrap lg:items-center gap-3 mt-5"></section>
      <section className="flex items-center justify-between gap-2">
        <button className='flex justify-center items-center size-8 border-2 border-secondary-tw rounded-md text-secondary-tw prev-new'>
          <ChevronRight size={22} />
        </button>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          loop={true}
          navigation={{
            nextEl: '.next-new',
            prevEl: '.prev-new'
          }}
          spaceBetween={10}
          slidesPerView={3}
          breakpoints={{
            0: { slidesPerView: 1 },
            680: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 3 }
          }}
          autoplay={{ delay: 3000, disableOnInteraction: true }}
          draggable={true}
        >
          {isLoading ? (
            <div>
              <div className="grid grid-cols-3 gap-4 max-2xl:grid-cols-2 max-lg:grid-cols-1">
                {[1, 2, 3].map((i) => (
                  <div key={i} className={`relative flex items-center justify-center flex-col ${i === 2 || i === 1 ? 'lg:flex max-lg:hidden' : ''}`}>
                    <div className="l-load w-96 h-60 rounded-md max-lg:w-full"></div>
                    <div className="absolute z-20 bottom-3 flex flex-col items-center w-full px-2 space-y-1">
                      <div className="l-load-dt w-3/4 h-5 rounded"></div>
                      <div className="l-load-dt w-40 h-8 rounded-md"></div>
                    </div>
                  </div>
                ))} 
              </div>
            </div>
          ) : (
            achievements.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="bg-[#E6E6E6] shadow-md rounded-lg overflow-hidden border p-4 "
                style={{minHeight: '480px'}}>
                  <div className="relative h-64 w-full">
                    <Image
                      src={item.image || "/default-image.jpg"}
                      alt={item.title}
                      className="object-cover w-full h-full mb-2"
                      style={{ borderRadius: '16px', border: '2px solid #D4AD89' }}
                    />
                  </div>
                  <div className="p-1">
                    <h3 className="text-lg font-semibold text-[#5b2e47] mb-2 text-end mt-2">
                      {item.title}
                    </h3>
                    <Link to={`/achievements/${item.id}`} className="text-sm text-[#b18c5e] flex items-center gap-1">
                      ← {t('moreDetails')}
                    </Link>
                    <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
                      <div className="flex items-center gap-2">
                        <span className="icon"><img src={img7} alt="icon" /></span>
                        <span className="text text-[#b18c5e]">{item.year || "2021"} <br /><span className="text text-[#6A2F38]">{t('year')}</span></span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="icon"><img src={img8} alt="icon" /></span>
                        <span className="text text-[#b18c5e]">{item.number_trainer || "775"}<br /><span className="text text-[#6A2F38]">{t('trainees')}</span></span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="icon"><img src={img7} alt="icon" /></span>
                        <span className="text text-[#b18c5e]">{item.days || "94"} <br /><span className="text text-[#6A2F38]">{t('trainingDays')}</span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>

        <button className='flex justify-center items-center size-8 border-2 border-secondary-tw rounded-md text-secondary-tw next-new'>
          <ChevronLeft size={22} />
        </button>
      </section>
    </div>
  );
});

const AchievementDetails = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { URL } = useLanguage();

  const { data: achievement, error, isLoading } = useQuery({
    queryKey: ['achievement-details', id],
    queryFn: async () => {
      try {
        const response = await axios.get(`${URL}/home-pages/${id}`);
        return response?.data?.data;
      } catch (error) {
        throw new Error(t('custom.err'));
      }
    },
    staleTime: 15 * 60 * 1000, // 15 min
    cacheTime: 30 * 60 * 1000, // 30 min
    refetchOnWindowFocus: false,
    retry: 1
  });

  document.title = `${achievement?.title || t('routes.achievement-details')}`;

  if (error) {
    return (
      <div className="flex justify-center items-center relative z-50 bg-white">
        <p id="err">{error?.message}</p>
      </div>
    )
  };

  if (isLoading) {
    return (
      <>
        <div className="h-10 w-full l-load-dt"></div>
        <div className="l-load-p w-full space-y-2 px-20 py-8 max-lg:px-4">
          <div className="l-load-dt w-full h-96 rounded-lg"></div>
          <div className="w-14 h-4 rounded-lg l-load-dt"></div>
          <div className="w-32 h-4 rounded-lg l-load-dt"></div>
        </div>
        <div className="space-y-2 mt-8 px-20 max-lg:px-4">
          {
            [...Array(8)].map((_, i) => (
              <div key={i} className="l-load-dt h-4 rounded-md w-full"></div>
            ))
          }
        </div>

      </>
    )
  };

  return (
    <>
      <Breadcrumb pages={[t("routes.achievements"), `${achievement?.title || t("routes.achievement-details")}`]} />

      <main className="container p-0">
        <div className="grid grid-cols-[35%_60%] gap-8 max-lg:grid-cols-1 max-lg:px-2 "
        style={{marginBottom:'60px'}} >
          <div className="w-full   max-lg:h-full relative px-0 " >
            <Image
              src={achievement?.image}
              alt={achievement?.title}
              className={"w-full h-full rounded-lg object-cover"}
            />
          </div>
          <section className="space-y-4  p-4 " style={{ border: '1px solid #C7C7C7', borderRadius: '10px', padding: '20px' }}>
            <div className="flex items-center !gap-4 text-secondary-tw flex-wrap">

              {
                achievement.days &&
                <div className="flex items-center !gap-2">
                  <span>
                    <CalendarRange size={24} />
                  </span>
                  <span className="text-lg">
                    {achievement.days} {t('achievements.train-day')}
                  </span>
                </div>
              }

              {achievement.number_trainer &&
                <div className="flex items-center !gap-2">
                  <span>
                    <PersonStanding size={27} />
                  </span>
                  <span className="text-lg">
                    {achievement.number_trainer} {t('achievements.trainer')}
                  </span>
                </div>
              }

              {
                achievement?.date &&
                <div className="flex items-center !gap-2">
                  <span>
                    <CalendarHeart size={27} />
                  </span>
                  <span className="text-lg">
                    {achievement?.date}
                  </span>
                </div>
              }

            </div>
            <div className="space-y-4 !text-start">
              <h2 className="text-2xl font-black">{achievement?.title}</h2>
              <article dangerouslySetInnerHTML={{ __html: achievement?.description }} />
            </div>
          </section>
        </div>
        <h3 className="text-2xl font-bold mb-4  mt-4 text-right"
        >أهم الأنجازات :</h3>
        <AnotherAchievments />
      </main>
    </>
  );
};

export default AchievementDetails;